/*
 * IcFmtpApp.tsx
 *
 * Created by Dr. Maximillian Dornseif in huWaWi3
 * Copyright (c) 2023 HUDORA GmbH
 */

import { useQuery } from '@apollo/client';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { LadeChecker } from '@hudora/hd-react-components';
import Stack from '@mui/material/Stack';
import gql from 'graphql-tag';
import React, { useState } from 'react';

import { HdcTable } from '../hdjslib/components/HdcTable';

const LIST_QUERY = gql`
  query FMTP($queue: String!, $deleted: Boolean!) {
    fmtpMessages(queue: $queue, deleted: $deleted) {
      content_type
      created_at
      deleted_at
      guid
      id
      message_queue_name
      url
    }
  }
`;

const options: IDropdownOption[] = [
  { key: 'Rechnungsdrucker', text: 'Rechnungsdrucker' },
  { key: 'LG200_kommi', text: 'LG200_kommi' },
];

export function IcFmtpApp() {
  const [deleted, setDeleted] = useState(true);
  const [queue, setQueue] = useState('Rechnungsdrucker');

  return (
    <div>
      <Stack direction="row" spacing={2} justifyContent="center">
        <Dropdown
          placeholder="Nachrichten-Art wählen"
          options={options}
          selectedKey={[queue]}
          onChange={(ev: React.FormEvent<HTMLElement>, option: IDropdownOption) => setQueue(`${option.key}`)}
        />
        <Checkbox
          label="Gelöschte Nachrichten anzeigen"
          defaultChecked={deleted}
          onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => setDeleted(isChecked)}
        />
      </Stack>

      <WaWiFmtpAppInner deleted={deleted} queue={queue} />
    </div>
  );
}

function WaWiFmtpAppInner(props: { queue: string; deleted: boolean }) {
  const { loading, error, data } = useQuery(LIST_QUERY, {
    pollInterval: 30 * 1000,
    variables: { queue: props.queue, deleted: props.deleted },
  });

  return (
    <div>
      <LadeChecker loading={loading} error={error} label="Lade" />
      <HdcTable title="FMTP" rowData={data?.fmtpMessages} />
    </div>
  );
}
